import { Search } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useBoundStore } from '@/shared/store';
import type { NaverLocalSearchItem } from '@/shared/types';
import { HighlightText } from '@/shared/ui';

const NAVER_COORD_SCALE = 10000000;

type SearchNaverResultItemProps = {
	suggestion: NaverLocalSearchItem;
	highlight: string;
};

const SearchNaverResultItem = ({
	suggestion,
	highlight,
}: SearchNaverResultItemProps) => {
	const navigate = useNavigate();
	const setSelectedPlace = useBoundStore((store) => store.setSelectedPlace);

	const handleClick = () => {
		setSelectedPlace({
			lat: Number(suggestion.mapy) / NAVER_COORD_SCALE,
			lng: Number(suggestion.mapx) / NAVER_COORD_SCALE,
		});
		navigate('/stations');
	};

	return (
		<li className="w-full list-none">
			<button
				type="button"
				onClick={handleClick}
				className="flex w-full cursor-pointer items-center gap-2 px-5 py-3 text-left transition-colors hover:bg-mantang-gray-100"
			>
				<Search className="size-4 shrink-0 text-mantang-gray-500" />
				<p className="min-w-0 flex-1 truncate text-left font-inter font-medium text-mantang-gray-900 text-sm">
					<HighlightText highlight={highlight}>
						{suggestion.title.replace(/<[^>]*>/g, '')}
					</HighlightText>
				</p>
			</button>
		</li>
	);
};

export default SearchNaverResultItem;
